import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAuthToken } from '../../features/auth/authSlice';

let activeChatConversationId = null;

export const setActiveChatConversationId = (conversationId) => {
  const numericId = Number(conversationId);
  activeChatConversationId = Number.isInteger(numericId) && numericId > 0 ? numericId : null;
};

const detailFromServiceWorkerMessage = (event) => {
  if (event.data?.type !== 'CHAT_PUSH_RECEIVED') return null;

  const data = event.data.payload?.data || {};
  return {
    type: 'chat.message.created',
    bodyPreview: data.bodyPreview || event.data.payload?.body,
    conversationId: data.conversationId,
    conversationType: data.conversationType,
    nightId: data.nightId,
    senderName: data.senderName,
  };
};

const ChatNotificationBridge = () => {
  const token = useSelector(selectAuthToken);

  useEffect(() => {
    if (!token) return undefined;

    const revalidateChat = (detail) => {
      if (detail?.type !== 'chat.message.created') return;

      const conversationId = Number(detail.conversationId);
      if (conversationId && conversationId === activeChatConversationId) return;

      window.dispatchEvent(new CustomEvent('thetavern:chat-revalidate'));
    };

    const handleServerEvent = (event) => revalidateChat(event.detail || {});
    const handleServiceWorkerMessage = (event) => {
      const detail = detailFromServiceWorkerMessage(event);
      if (detail) revalidateChat(detail);
    };

    window.addEventListener('thetavern:server-event', handleServerEvent);
    navigator.serviceWorker?.addEventListener('message', handleServiceWorkerMessage);

    return () => {
      window.removeEventListener('thetavern:server-event', handleServerEvent);
      navigator.serviceWorker?.removeEventListener('message', handleServiceWorkerMessage);
    };
  }, [token]);

  return null;
};

export default ChatNotificationBridge;
